import {DetailTable} from '../../../mapping-classes/detail-table';

export class Cards implements DetailTable {
  shieldedText = 'Afgeschermd'; /* TODO: change to credit card context*/
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(physicalCards: any) {
    if (!physicalCards || physicalCards.continents === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = physicalCards.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(physicalCards);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen deelnemende rekeningen.';
  }

  setRowHeaders() {
    /* TODO: change to credit card context*/
    this.rowHeaders = [
      'securedCardNumber',
      'status',
      'validUntil',
      'creationDate',
      'notificationPassFactoryDate',
      'cancellationDate',
      'replacementDate',
      'blocked',
      'blockReason',
      'unblockPermitted',
      'requestReason',
    ];
  }

  setRowData(cards) {
    cards.forEach((physicalCard) => {
      if (this.restrictedData) {
        physicalCard.compensationLimit = this.shieldedText;
        physicalCard.actualBalance = this.shieldedText;
      }
      this.rowData.push(physicalCard);
    });
  }
}
